<template>
  <!-- :bodyStyle="{paddingTop:'0px'}" :headStyle="{borderBottom:'0px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="订单号" v-bind="searchItemLayout">
            <a-input v-model="queryParams.travelMadeOrderNo" placeholder="请输入订单号"></a-input>
          </a-form-item>
          <a-form-item label="方案名称" v-bind="searchItemLayout">
            <a-input v-model="queryParams.travelMadeOrderName" placeholder="请输入方案名称"></a-input>
          </a-form-item>
          <a-form-item label="来源用户" v-bind="searchItemLayout">
            <a-input v-model="queryParams.memberKey" placeholder="昵称/手机号"></a-input>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="联系人" v-bind="searchItemLayout">
            <a-input v-model="queryParams.travelMadeOrderContact" placeholder="请输入联系人"></a-input>
          </a-form-item>
          <a-form-item label="联系电话" v-bind="searchItemLayout">
            <a-input v-model="queryParams.travelMadeOrderMobile" placeholder="请输入联系电话"></a-input>
          </a-form-item>
          <a-form-item label="第三方订单号" v-bind="searchItemLayout">
            <a-input v-model="queryParams.travelMadeOrderTradeNO" placeholder="请输入"></a-input>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="下单时间" v-bind="searchItemLayout">
            <a-range-picker @change="onOrderDateChange" :value="selectedOrderDate" style="width: 100%"/>
          </a-form-item>
          <a-form-item label="出游时间" v-bind="searchItemLayout">
            <a-range-picker @change="onDateTravelChange" :value="selectedTravelDate" style="width: 100%"/>
          </a-form-item>
          <a-form-item label="订单状态" v-bind="searchItemLayout">
            <a-select style="width: 100%"
                      v-model="queryParams.travelMadeOrderStatus"
                      placeholder="请选择" allowClear
            >
              <a-select-option :value="999">全部</a-select-option>
              <a-select-option :value="0">待支付</a-select-option>
              <a-select-option :value="1">已支付</a-select-option>
              <a-select-option :value="2">已退款</a-select-option>
              <a-select-option :value="3">已关闭</a-select-option>
              <a-select-option :value="4">申请退款</a-select-option>
              <a-select-option :value="5">拒绝退款</a-select-option>
            </a-select>
          </a-form-item>
        </search-list>
      </search-header>
      <search-header>
        <search-list>
          <a-form-item label="支付状态" v-bind="searchItemLayout">
            <a-select style="width: 100%"
                      v-model="queryParams.travelMadeOrderPayType"
                      placeholder="请选择" allowClear
            >
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option v-for="(item,index) in paymentList" :key="index" :value="item.paymentChannelId">
                {{ item.paymentChannelName }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="批量设置编号" v-bind="searchItemLayout">
            <a-input
              v-model="queryParams.enterpriseTravelSettingCode"
              placeholder="请输入批量设置编号"
              allowClear
            />
          </a-form-item>
          <a-form-item style="margin-left:5%;">
            <a-button type="primary" @click="searchBtn">查询</a-button>
            <a-button @click="exportOrder">导出</a-button>
            <a-button type="primary" icon="plus" @click="createEvent(0)">新建</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-page-table
      ref="table"
      rowKey="travelMadeOrderNo"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      params-path="orderCustomMade/getOrderCustomMadeList"
      base-key="orderUrl"
    >
      <template slot="downloadSlot" slot-scope="data">
        <a :href="data.text" target="_blank">下载</a>
      </template>
      <template slot="numSlots" slot-scope="data">
        <div>成人X{{ data.record.travelMadeOrderAdultsNum }}</div>
        <div>儿童X{{ data.record.travelMadeOrderChildNum }}</div>
      </template>
      <template slot="contactSlots" slot-scope="data">
        <div>{{ data.record.travelMadeOrderContact }}</div>
        <div>{{ data.record.travelMadeOrderMobile }}</div>
      </template>
      <span class="price-class" slot="priceSlots" slot-scope="data">￥{{ data.text }}</span>
      <div slot="action" slot-scope="data">
      <span v-if="data.record.travelMadeOrderStatus==0">
        <a @click="onEventShare(data.record)">分享</a>
        <a-divider type="vertical"/>
        <a @click="createEvent(data.record.travelMadeOrderId)">编辑</a>
      </span>
        <a v-else @click="goOrderDetail(data.record.travelMadeOrderNo)">订单详情</a>
      </div>
    </custom-page-table>
    <a-modal title="分享链接"
             :visible="visiblePopup"
             :footer="null"
             @cancel="handleCancel"
    >
      <a-textarea v-model="config.common.bdUrl" placeholder="分享链接" :rows="4" disabled/>
      <div class="mt15">
        <a-button @click="onCopy">复制链接</a-button>
        <BaiduShare :config="config" style="vertical-align: -30px;margin-left:10px;"></BaiduShare>
      </div>

    </a-modal>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import BaiduShare from '@/customComponents/BaiduShare/BaiduShare'

export default {
  name: 'CustomOrderList',
  mixins: [searchForm],
  components: {
    BaiduShare
  },
  data() {
    return {
      selectedOrderDate: undefined,
      selectedTravelDate: undefined,
      visiblePopup: false,
      paymentList: [],
      merchantId: this.$store.getters.userInfo.merchantId,
      merchantLoginType: this.$store.getters.userInfo.merchantLoginType,
      queryParams: {
        travelMadeOrderStatus: 999,
        travelMadeOrderPayType: 0,
        travelMadeOrderNo: '',
        travelMadeOrderName: '',
        travelMadeOrderContact: '',
        travelMadeOrderMobile: '',
        memberKey: '',
        travelMadeOrderTradeNO: '',
        enterpriseTravelSettingCode: ''
      },
      columns: [
        {
          title: '订单号',
          dataIndex: 'travelMadeOrderNo'
        },
        {
          title: '批量设置编号',
          dataIndex: 'enterpriseTravelSettingCode'
        },
        {
          title: '方案名称',
          dataIndex: 'travelMadeOrderName'
        },
        {
          title: '方案附件',
          dataIndex: 'travelMadeOrderPdfUrl',
          scopedSlots: { customRender: 'downloadSlot' },
          width: '60px'
        },
        {
          title: '购买数',
          dataIndex: 'travelMadeOrderAdultsNum',
          scopedSlots: { customRender: 'numSlots' },
          width: '95px'
        },
        {
          title: '下单用户',
          dataIndex: 'travelMadeOrderContact',
          scopedSlots: { customRender: 'contactSlots' }
        },
        {
          title: '金额',
          dataIndex: 'travelMadeOrderAmt',
          scopedSlots: { customRender: 'priceSlots' }
        },
        {
          title: '下单时间',
          dataIndex: 'travelMadeOrderCreateTime'
        },
        {
          title: '支付时间',
          dataIndex: 'travelMadeOrderPayTime'
        },
        {
          title: '状态',
          dataIndex: 'travelMadeOrderStatusStr',
          width: '75px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '115px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      config: {
        common: {
          bdText: '',
          bdDesc: '',
          bdUrl: '',
          bdPic: '',
          bdSign: 'off'
        },
        share: [
          {
            bdSize: 24
          }
        ],
        image: [
          {
            viewType: 'list',
            viewPos: 'top',
            viewColor: 'black',
            viewSize: '16',
            viewList: ['qzone', 'tsina', 'huaban', 'tqq', 'renren']
          }
        ]
      }
    }
  },
  mounted() {
    this.getLogUtils().logWithTag('user', this.$store.getters.userInfo)
    this.getPayStateList()
  },
  activated() {
    this.getLogUtils().logWithTag('activated', 'activated')
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'BookList', title: '预约列表' },
      { name: 'CustomOrderList', title: '订单管理' }
    ])
    if (this.$route.query.updateFlag) {
      this.getLogUtils().logWithTag('activated', this.$route.query.updateFlag)
      this.$refs.table.refresh(true)
    }
  },
  methods: {
    // 获取支付状态
    getPayStateList() {
      this.getHttpServices().getOrderService().post('order/findPaymentChannels')
        .then(res => {
          this.getLogUtils().logWithTag('==getOrderStateList==', res)
          this.paymentList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //日期变更
    onOrderDateChange(dates, dateStrArr) {
      this.selectedOrderDate = dates
      this.queryParams.travelMadeOrderCreateStartTime = dateStrArr[0]//下单开始时间
      this.queryParams.travelMadeOrderCreateEndTime = dateStrArr[1]//下单结束时间
    },
    //日期变更
    onDateTravelChange(dates, dateStrArr) {
      this.selectedTravelDate = dates
      this.queryParams.orderTravelTimeStart = dateStrArr[0]//出游开始日期
      this.queryParams.travelMadeOrderStartDate = dateStrArr[1]//出游结束日期
    },
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    handleCancel() {
      this.visiblePopup = false
    },
    onEventShare(data) {
      this.visiblePopup = true
      this.config.common = Object.assign({}, this.config.common, {
        bdText: data.travelMadeOrderName,
        bdDesc: data.travelMadeOrderName,
        bdUrl: data.travelMadeOrderUrl
      })
    },
    goOrderDetail(orderNo) {
      this.getLogUtils().logWithTag('record==', orderNo)
      const inTravelMode = this.$route.name === 'TravelMode'
      this.$router.push({
        name: inTravelMode ? 'TravelOrderDetail' : 'CustomOrderDetails',
        query: {
          orderNo: orderNo,
          serverUniqueId: this.$route.query.serverUniqueId,
          backTab: inTravelMode ? 'order' : undefined
        }
      })
    },
    createEvent(id) {
      this.getLogUtils().logWithTag('record==', id)
      const inTravelMode = this.$route.name === 'TravelMode'
      this.$router.push({
        name: inTravelMode ? 'TravelNewOrder' : 'NewOrders',
        query: {
          orderId: id,
          serverUniqueId: this.$route.query.serverUniqueId,
          backTab: inTravelMode ? 'order' : undefined
        }
      })
    },
    onCopy() {
      this.$copyText(this.config.common.bdUrl).then(message => {
        this.getLogUtils().logWithTag('copy', message)
        this.$message.success('复制完毕')
      }).catch(err => {
        this.getLogUtils().logWithTag('copy.err', err)
        this.$message.error('复制失败')
      })
    },
    // 导出
    exportOrder() {
      //去除null
      this.queryParams.travelMadeOrderCreateEndTime = this.queryParams.travelMadeOrderCreateEndTime ? this.queryParams.travelMadeOrderCreateEndTime : ''
      this.queryParams.travelMadeOrderCreateStartTime = this.queryParams.travelMadeOrderCreateStartTime ? this.queryParams.travelMadeOrderCreateStartTime : ''
      this.queryParams.travelMadeOrderStartDate = this.queryParams.travelMadeOrderStartDate ? this.queryParams.travelMadeOrderStartDate : ''
      this.queryParams.travelMadeOrderEndDate = this.queryParams.travelMadeOrderEndDate ? this.queryParams.travelMadeOrderEndDate : ''
      if (!this.queryParams.travelMadeOrderCreateStartTime && !this.queryParams.travelMadeOrderStartDate) {
        this.$message.error('请选择下单或出游时间')
        return
      }
      if (this.queryParams.travelMadeOrderCreateStartTime) {
        if (!this.queryParams.travelMadeOrderCreateEndTime) {
          this.$message.error('请选择下单截止时间')
          return
        }
      }
      if (this.queryParams.travelMadeOrderStartDate) {
        if (!this.queryParams.travelMadeOrderEndDate) {
          this.$message.error('请选择出游截止时间')
          return
        }
      }
      let url = this.getAppConfig().orderUrl + 'orderCustomMade/getOrderCustomMadeDc' + '?merchantLoginType=' + this.merchantLoginType + '&merchantId=' + this.merchantId + '&orderNo=' + this.queryParams.travelMadeOrderNo + '&tradeNO=' + this.queryParams.travelMadeOrderTradeNO + '&orderName=' + this.queryParams.travelMadeOrderName + '&contact=' + this.queryParams.travelMadeOrderContact + '&mobile=' + this.queryParams.travelMadeOrderMobile + '&status=' + this.queryParams.travelMadeOrderStatus + '&payType=' + this.queryParams.travelMadeOrderPayType + '&startTime=' + this.queryParams.travelMadeOrderCreateStartTime + '&endTime=' + this.queryParams.travelMadeOrderCreateEndTime + '&startDate=' + this.queryParams.travelMadeOrderStartDate + '&endDate=' + this.queryParams.travelMadeOrderEndDate + '&memberKey=' + this.queryParams.memberKey
      this.getLogUtils().logWithTag('wwwww', url)
      window.open(url)
    }
  }

}
</script>
<style scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.price-class {
  color: #fea834;
}

.mt15 {
  margin-top: 15px;
}
</style>